package com.zaurh.mapquizwebsite.data.repository

import com.zaurh.mapquizwebsite.data.service.DailyRewardsApi
import com.zaurh.mapquizwebsite.data.service.UserApi
import com.zaurh.mapquizwebsite.domain.model.DailyRewardDO
import com.zaurh.mapquizwebsite.domain.model.GetDailyRewardsDO
import com.zaurh.mapquizwebsite.domain.model.UserDataDO
import com.zaurh.mapquizwebsite.domain.repository.DailyRewardsRepository
import com.zaurh.mapquizwebsite.domain.repository.UserRepository
import com.zaurh.mapquizwebsite.utils.Result
import com.zaurh.mapquizwebsite.utils.safeApiCall

class DailyRewardsRepositoryImpl(
    private val api: DailyRewardsApi
): DailyRewardsRepository {
    override suspend fun getDailyRewards(): Result<GetDailyRewardsDO> {
        return safeApiCall { api.getDailyRewards() }
    }

    override suspend fun claimDailyReward(): Result<Unit> {
        return safeApiCall { api.claimDailyReward() }
    }
}